// extracted by mini-css-extract-plugin
export default {"white_box_container":"index-module--white_box_container--xPe5O","fullWidthContent":"index-module--fullWidthContent--L5cRv","yellow":"index-module--yellow--17BAA"};